<div class="body widget-list-body">
    <div class="widget-header">
        <span class="headline">Angebote</span>
        <button mat-icon-button *ngIf="currentFilterType" [matMenuTriggerFor]="sortMenu" matTooltip="Sortierung anpassen">
            <mat-icon>sort_by_alpha</mat-icon>
        </button>
        <button mat-icon-button (click)="showSearchInput = !showSearchInput" [matTooltip]="showSearchInput? 'Suchfeld ausblenden' : 'Suchfeld einblenden'">
            <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button [disabled]="defaultView" (click)="loadContent()" color="warn" matTooltip="Startsicht anzeigen">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <mat-form-field *ngIf="showSearchInput" class="widget-search-input">
        <mat-label>Suchbegriff</mat-label>
        <input matInput [(ngModel)]="searchFilter" (keyup.enter)="sendSearch()" appAutofocus />
        <button matSuffix mat-icon-button (click)="sendSearch()">
            <mat-icon>search</mat-icon>
        </button>
    </mat-form-field>
    <div class="widget-list-content">
        <div class="entry" *ngFor="let offer of entries" (click)="editOffer(offer)">
            <app-offer-preview [offer]="offer"></app-offer-preview>
        </div>
    </div>
</div>

<mat-menu #sortMenu="matMenu">
    <button mat-menu-item *ngFor="let criteria of currentFilterType.criteria" class="dropdown-item" (click)="setFilter(criteria)">
        <mat-icon class="dropdown-icon" [ngClass]="criteria.value == sortAttribute? 'active': 'inactive'">done</mat-icon>
        <span>{{criteria.title}}</span>
        <ng-container *ngIf="criteria.value == sortAttribute">
            <mat-icon *ngIf="!sortDsc">arrow_drop_up</mat-icon>
            <mat-icon *ngIf="sortDsc">arrow_drop_down</mat-icon>
        </ng-container>
    </button>
</mat-menu>
